import { BuiltinDoorId } from "building-types/doors/BuiltinDoorId";
import { polyLine2New } from "geom/polyLine2Types";

export function isDoorSwing(doorId: string) {
  const doorNoSwing: (BuiltinDoorId | string)[] = [BuiltinDoorId.OPEN_FULL, BuiltinDoorId.FIREPLACE];
  return !doorNoSwing.includes(doorId);
}

export const DOOR_TRIM_WIDTH = 3;
// exterior door frame
export const DOOR_TRIM_DEPTH = 0.5;
export const DOOR_UNIT_TRIM_CROSS_SECTION = polyLine2New([
  0,
  0,
  0,
  DOOR_TRIM_DEPTH,
  DOOR_TRIM_WIDTH,
  DOOR_TRIM_DEPTH,
  DOOR_TRIM_WIDTH,
  0,
  0,
  0,
]);
